
import { GoTemplateDataArray } from "@/utils/go-template-data-structure/array";
import { GoTemplateDataObject } from "@/utils/go-template-data-structure/object";
import { GoTemplateDataRoot, IDisplayedProp } from "@/utils/go-template-data-structure/root";
import { GoTemplateDataString } from "@/utils/go-template-data-structure/string";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			value: null as null | IDisplayedProp
		};
	},
	props: {
		text: String,
		cursorPosition: Number
	},
	computed: {
		items():ISelectItem<IDisplayedProp>[] {
			return this.templateData.getDisplayedProperties(this.text, this.cursorPosition);
		},
		templateData():GoTemplateDataRoot {
			return new GoTemplateDataRoot([
				new GoTemplateDataObject("Contact", [
					new GoTemplateDataString("Nr", this.$ct("contact.Nr")),
					new GoTemplateDataString("Info", this.$ct("contact.Info")),
					new GoTemplateDataString("CompanyName", this.$ct("contact.CompanyName")),
					new GoTemplateDataString("FirstName", this.$ct("contact.FirstName")),
					new GoTemplateDataString("LastName", this.$ct("contact.LastName")),
					new GoTemplateDataString("AddressLine1", this.$ct("contact.AddressLine1")),
					new GoTemplateDataString("AddressLine2", this.$ct("contact.AddressLine2")),
					new GoTemplateDataString("Number", this.$ct("contact.Number")),
					new GoTemplateDataString("Box", this.$ct("contact.Box")),
					new GoTemplateDataString("Postal", this.$ct("contact.Postal")),
					new GoTemplateDataString("Email", this.$ct("contact.Email")),
					new GoTemplateDataString("Phone", this.$ct("contact.Phone")),
					new GoTemplateDataString("Fax", this.$ct("contact.Fax")),
					new GoTemplateDataString("City", this.$ct("contact.City")),
					new GoTemplateDataString("CountryCode", this.$ct("contact.CountryCode")),
					new GoTemplateDataString("FullName", this.$ct("contact.FullName")),
					new GoTemplateDataString("FullNameReverse", this.$ct("contact.FullNameReverse")),
					new GoTemplateDataString("CompanyOrFullName", this.$ct("contact.CompanyOrFullName")),
					new GoTemplateDataString("ClientPortalUrl", this.$ct("contact.ClientPortalUrl")),
				]),
				new GoTemplateDataArray("Sales", "sale", [
					new GoTemplateDataString("Nr", this.$ct("sale.Nr")),
					new GoTemplateDataString("ToPrintMessage", this.$ct("sale.ToPrintMessage")),
					new GoTemplateDataString("ToNotPrintMessage", this.$ct("sale.ToNotPrintMessage")),
					new GoTemplateDataString("InvoiceDate", this.$ct("sale.InvoiceDate")),
					new GoTemplateDataString("ExpirationDate", this.$ct("sale.ExpirationDate")),
					new GoTemplateDataString("TotalExcVAT", this.$ct("sale.TotalExcVAT")),
					new GoTemplateDataString("TotalVAT", this.$ct("sale.TotalVAT")),
					new GoTemplateDataString("TotalIncVAT", this.$ct("sale.TotalIncVAT")),
					new GoTemplateDataString("TotalOpen", this.$ct("sale.TotalOpen")),
					new GoTemplateDataString("TotalOpenWithCosts", this.$ct("sale.TotalOpenWithCosts")),
					new GoTemplateDataString("Cost", this.$ct("sale.Cost")),
					new GoTemplateDataString("Interest", this.$ct("sale.Interest")),
					new GoTemplateDataString("PublicSaleUrl", this.$ct("sale.PublicSaleUrl")),
				], this.$ct("sales")),
			]);
		}
	},
	methods: {
		add() {
			if (!this.value) return;
			if (this.value.type == "text") {
				this.$emit("add", this.value.value);
			}else if (this.value.type == "link"){
				this.$emit("add-link", this.value.value, this.value.args[0]);
			}
			this.value = null;
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
